import React from 'react';
import { PageBaseComponent } from '../../../library/cms/page-components';
import EditIcon from '../../../library/cms/edit-icon';
import { MDCDialog,MDCTextInput, MDCFormCheckbox } from '../../../library/components/mdc-components';


export class FairfieldButtonLinkComponent extends PageBaseComponent {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        super.componentDidMount();
    }

    onGetContent(data) {
        var content = {
            link: this.state.component.content.link,
            newTarget: this.state.component.content.newTarget,
            label: this.state.component.content.label
        }
        var data = {
            key: this.props.contentKey,
            content: content
        };
        return data;
    }

    onDialogAccept = () => {

    }

    onDialogCancel = () => {
    }

    onEditClick = (event) => {
        this.Dialog.show();
    }

    onChange = (event) => {
        var value = event.target.value;
        this.state.component.content.link = value;
        this.setState(this.state);
    }

    onLabelChange = (event) => {
        var value = event.target.value;
        this.state.component.content.label = value;
        this.setState(this.state);
    }

    onNewTargetChange = (event) => {
        var checked = event.target.checked;
        this.state.component.content.newTarget = checked;
        this.setState(this.state);
    }

    render() {
        let active = this.state.component.active;
        let content = this.state.component.content;
        let editIconPositionCls=this.props.editIconPositionCls ? this.props.editIconPositionCls : 'btn-link-absolute-position';
        let icon = this.props.icon ? this.props.icon : 'arrow.png';
        return (
            <div>
                <div className="relative">
                    <div className={editIconPositionCls}>
                        <EditIcon onClick={this.onEditClick} active={active}>
                            <MDCDialog
                                ref={(ref) => this.Dialog = ref}
                                onDialogAccept={this.onDialogAccept}
                                onDialogCancel={this.onDialogCancel}
                                accept="Save"
                                header="Button Properties"
                            >
                                <div>
                                    <MDCTextInput label="Button Label" onChange={this.onLabelChange} value={content.label} />
                                    <MDCTextInput label="Button Link" onChange={this.onChange} value={content.link} />
                                    <div className="align-left-1">
                                        <MDCFormCheckbox label="Open in New Tab" onCheckedChange={this.onNewTargetChange} checked={content.newTarget} />
                                    </div>
                                   
                                </div>
                            </MDCDialog>
                        </EditIcon>
                    </div>
                    <a className={this.props.buttonCss} href={content.link} target={content.newTarget ? '_blank' : '_self'}>{content.label} <img src={'/images/icons/' + icon}/></a>
                </div>
            </div>
        );
    }
}

export class FairfieldPdfLinkComponent extends PageBaseComponent {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        super.componentDidMount();
    }

    onGetContent(data) {
        var content = {
            link: this.state.component.content.link,
            newTarget: this.state.component.content.newTarget,
            label: this.state.component.content.label
        }
        var data = {
            key: this.props.contentKey,
            content: content
        };
        return data;
    }

    onDialogAccept = () => {

    }

    onDialogCancel = () => {
    }

    onEditClick = (event) => {
        this.Dialog.show();
    }

    onChange = (event) => {
        var value = event.target.value;
        this.state.component.content.link = value;
        this.setState(this.state);
    }

    onLabelChange = (event) => {
        var value = event.target.value;
        this.state.component.content.label = value;
        this.setState(this.state);
    }

    onNewTargetChange = (event) => {
        var checked = event.target.checked;
        this.state.component.content.newTarget = checked;
        this.setState(this.state);
    }

    render() {
        let active = this.state.component.active;
        let content = this.state.component.content;
        let editIconPositionCls=this.props.editIconPositionCls ? this.props.editIconPositionCls : 'btn-link-absolute-position';
        let icon = this.props.icon ? this.props.icon : 'arrow.png';
        let buttonCss = this.props.buttonCss ? this.props.buttonCss : 'pdf-link';

        // No link set + edit mode OFF → render nothing (no dead <a>).
        // The CMS toolbar's edit toggle flips `active`, revealing the
        // component so the admin can set the link/label.
        if (!content.link && !active) {
            return null;
        }

        return (
            <div>
                <div className="relative">
                    <div className={editIconPositionCls}>
                        <EditIcon onClick={this.onEditClick} active={active}>
                            <MDCDialog
                                ref={(ref) => this.Dialog = ref}
                                onDialogAccept={this.onDialogAccept}
                                onDialogCancel={this.onDialogCancel}
                                accept="Save"
                                header="Button Properties"
                            >
                                <div>
                                    <MDCTextInput label="Button Label" onChange={this.onLabelChange} value={content.label} />
                                    <MDCTextInput label="Button Link" onChange={this.onChange} value={content.link} />
                                    <div className="align-left-1">
                                        <MDCFormCheckbox label="Open in New Tab" onCheckedChange={this.onNewTargetChange} checked={content.newTarget} />
                                    </div>
                                   
                                </div>
                            </MDCDialog>
                        </EditIcon>
                    </div>
                    <a className={buttonCss} href={content.link} target={content.newTarget ? '_blank' : '_self'}><img src={'/images/icons/pdf-icon.png'}/> {content.label} </a>
                </div>
            </div>
        );
    }
}

// Plain rectangular CMS button (Contact-page style — ui-button secondary,
// no arrow/pdf icon). Used for the gallery-page button row (up to 4 per
// page). Hides entirely when no link is set and edit mode is off; in edit
// mode an empty button renders a placeholder label so the admin has a
// visible edit target.
export class FairfieldGalleryButtonComponent extends PageBaseComponent {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        super.componentDidMount();
    }

    onGetContent(data) {
        var content = {
            link: this.state.component.content.link,
            newTarget: this.state.component.content.newTarget,
            label: this.state.component.content.label
        }
        var data = {
            key: this.props.contentKey,
            content: content
        };
        return data;
    }

    onDialogAccept = () => {
    }

    onDialogCancel = () => {
    }

    onEditClick = (event) => {
        this.Dialog.show();
    }

    onChange = (event) => {
        var value = event.target.value;
        this.state.component.content.link = value;
        this.setState(this.state);
    }

    onLabelChange = (event) => {
        var value = event.target.value;
        this.state.component.content.label = value;
        this.setState(this.state);
    }

    onNewTargetChange = (event) => {
        var checked = event.target.checked;
        this.state.component.content.newTarget = checked;
        this.setState(this.state);
    }

    render() {
        let active = this.state.component.active;
        let content = this.state.component.content;
        // No link + edit mode off → render nothing (no dead button).
        if (!content.link && !active) {
            return null;
        }
        let editIconPositionCls = this.props.editIconPositionCls ? this.props.editIconPositionCls : 'btn-link-absolute-position';
        let buttonCss = this.props.buttonCss ? this.props.buttonCss : 'ui-button secondary min-width ink gallery-cms-button';
        let label = content.label;
        if (!label && active) label = '(Set Label)';

        return (
            <div className="gallery-cms-button-wrap">
                <div className="relative">
                    <div className={editIconPositionCls}>
                        <EditIcon onClick={this.onEditClick} active={active}>
                            <MDCDialog
                                ref={(ref) => this.Dialog = ref}
                                onDialogAccept={this.onDialogAccept}
                                onDialogCancel={this.onDialogCancel}
                                accept="Save"
                                header="Button Properties"
                            >
                                <div>
                                    <MDCTextInput label="Button Label" onChange={this.onLabelChange} value={content.label} />
                                    <MDCTextInput label="Button Link" onChange={this.onChange} value={content.link} />
                                    <div className="align-left-1">
                                        <MDCFormCheckbox label="Open in New Tab" onCheckedChange={this.onNewTargetChange} checked={content.newTarget} />
                                    </div>
                                </div>
                            </MDCDialog>
                        </EditIcon>
                    </div>
                    <a className={buttonCss} href={content.link} target={content.newTarget ? '_blank' : '_self'}>{label}</a>
                </div>
            </div>
        );
    }
}

export class FairfieldButtonLink extends React.Component {
    constructor(props) {
        super(props)
        this.state={
            label:this.props.label,
            link:this.props.link
        };
    }

    componentDidMount() {
        
    }

    
    onDialogAccept = () => {
        this.props.onSave(this.state.label,this.state.link);
    }

    onDialogCancel = () => {
    }

    onEditClick = (event) => {
        this.Dialog.show();
    }

    onChange = (event) => {
        var value = event.target.value;
        this.setState({link:value});
    }

    onLabelChange = (event) => {
        var value = event.target.value;
        this.setState({label:value});
    }

    render() {
        let active = this.props.active;
        let link=this.props.link;
        let label=this.props.label;
        let editIconPositionCls = this.props.editIconPositionCls ? this.props.editIconPositionCls : 'btn-link-absolute-position';
        let icon = this.props.icon ? this.props.icon : 'arrow.png';

        return (
            <div>
                <div className="relative">
                    <div className={editIconPositionCls}>
                        <EditIcon onClick={this.onEditClick} active={active}>
                            <MDCDialog
                                ref={(ref) => this.Dialog = ref}
                                onDialogAccept={this.onDialogAccept}
                                onDialogCancel={this.onDialogCancel}
                                accept="Save"
                                header="Button Properties"
                            >
                                <div>
                                    <MDCTextInput label="Button Label" onChange={this.onLabelChange} value={label} />
                                    <MDCTextInput label="Button Link" onChange={this.onChange} value={link} />

                                </div>
                            </MDCDialog>
                        </EditIcon>
                    </div>
                    <a className={this.props.buttonCss} href={link}>{label} <img src={'/images/icons/' + icon} /></a>
                </div>
            </div>
        );
    }
}